import { bindable, customElement } from "aurelia-framework";
import { Router } from "aurelia-router";

@customElement('portfolio-link')
export class PortfolioLink {

  @bindable()
  params: any;

  url: string;

  constructor(private router: Router) {
  }

  attached() {
    if (this.params.data != null) {
      this.url = 'instrument/' + this.params.getValue()
    }
  }
}


